export enum TransactionDirection {
  IN = 'IN',
  OUT = 'OUT',
}
export enum FeeType {
  IN = 'IN',
  OUT = 'OUT',
  SELL = 'SELL',
  BUY = 'BUY',
  MERCHANT_IN = 'MERCHANT_IN',
  OUT_ABFPAY = 'OUT_ABFPAY',
  OUT_SEPA = 'OUT_SEPA',
  OUT_SWIFT = 'OUT_SWIFT',
}
export enum FeeDirection {
  IN = 'IN',
  OUT = 'OUT',
  BUY = 'BUY',
  SELL = 'SELL',
  MERCHANT_IN = 'MERCHANT_IN',
  OUT_ABFPAY = 'OUT_ABFPAY',
  OUT_SEPA = 'OUT_SEPA',
  OUT_SWIFT = 'OUT_SWIFT',
}

export enum TransactionStatus {
  PENDING = 'PENDING',
  EXECUTED = 'EXECUTED',
  FAILED = 'FAILED',
  CANCELED = 'CANCELED',
  AWAIT = 'AWAIT',
  IN_PROGRESS = 'IN_PROGRESS',
  PENDING_CONFIRMATION = 'PENDING_CONFIRMATION',
}

export enum TransactionOrderStatus {
  AWAIT = 'AWAIT',
  SENT = 'SENT',
  RETRY_SEND = 'RETRY_SEND',
  ORDERED = 'ORDERED',
  RETRY_ORDER = 'RETRY_ORDER',
  FILLED = 'FILLED',
  FAILED = 'FAILED',
}

export enum PaymentMethod {
  BLOCKCHAIN = 'BLOCKCHAIN',
  BANK = 'BANK',
  EXCHANGE = 'EXCHANGE',
}
